import axios from '../http_v2'

let send_m = (data) => { 
  // 按标签和分组发送短信
  return axios.post('marketcenter/sms2/markcenter/send', data)
}
let send_person = (data) => { 
  // 按标签和分组发送短信
  return axios.post('marketcenter/sms2/send', data)
}
let getTemplateList = (params) => {
  return axios.get('marketcenter/sms/template/get/audited', params)
}

let getTemplate  = (params) => {
  return axios.get('marketcenter/sms/template/get', params)
}
let saveTemplate = (data) => {
  return axios.post('marketcenter/sms/template/save', data)
}

let deleteTemplate = (params) => {
  return axios.get('marketcenter/sms/template/delete', params)
}

let getInsertField = (params) => {
  return axios.get('marketcenter/sms/markcenter/field', params)
}

export default {
  send: (params) => {
    // 活动中心发短信-通知类
    return axios.post('marketcenter/sms/send', params)
  },
  sendyx: (params) => {
    // 活动中心发短信-营销类
    return axios.post('marketcenter/sms/send/yx', params)
  },
  getMassageList: 'marketcenter/sms/task/get', //获取短信列表
  getTimeMessageList:'marketcenter/sms/timer/task/get',//获取定时发送短信
  updataTimeMessage:'marketcenter/sms/timer/task/update',//更新定时任务
  getMassageReport: 'marketcenter/sms/report/get', //获取短信报表
  getMassageReportDetail: 'marketcenter/sms/detail/get', //获取短信报表详情
  getReportDetailStats: 'marketcenter/sms/precent/get', //获取短信详情的统计信息
  deleteSms: 'marketcenter/sms/task/del', //删除短信信息
  deleteTimerSms: 'marketcenter/sms/timer/task/del', //删除定时短信任务

  send_m,
  send_person,
  getTemplateList, 
  getTemplate,//获取短信模板列表
  saveTemplate, //保存短信模板
  deleteTemplate, //删除短信模板
  getInsertField, //营销中心  获取插入短信字段
}
